<template>
  <div>
    <div class="text-xs-center">
      <v-dialog v-model="dialog" width="1200">
        <v-card min-height="400">
          <div>
            <v-toolbar flat color="white">
              <v-toolbar-title v-if="customer !=null">{{customer}} {{$t('addresses_crud.addresses')}}</v-toolbar-title>
              <v-divider class="mx-2" inset vertical></v-divider>
              <v-spacer></v-spacer>

              <address-create ref="addressCreater" :customer="customer" :countryCodes="countryCodes" @addressUploaded="initialize" @addressUpdated="initialize"/>
            </v-toolbar>
            <v-data-table 
                class="elevation-1"
                :headers="headers"
                :items="addresses"
                :pagination.sync="pagination"
                :rows-per-page-text="$t('addresses_crud.per_page')"
                :rows-per-page-items="rowsPerPageItems">
              <template v-slot:items="props">
                <td class="text-xs-left">{{ getCountryName(props.item.country) }}</td>
                <td class="text-xs-left">{{ props.item.city }}</td>
                <td class="text-xs-left">{{ props.item.street }}</td>
                <td class="text-xs-left">{{ props.item.post_code }}</td>
                <td class="text-xs-left">{{ props.item.phone }}</td>
                <td class="text-xs-left">{{ props.item.ref }}</td>
                <td class="justify-center layout px-0">
                  <v-icon small class="mr-2" v-tooltip="$t('addresses_crud.edit')" @click="editItem(props.item)">edit</v-icon>
                  <v-icon small v-tooltip="$t('addresses_crud.delete')" @click="deleteItem(props.item)">delete</v-icon>
                </td>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">{{$t('addresses_crud.reset')}}</v-btn>
              </template>
            </v-data-table>
          </div>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="dialog = false">{{$t('addresses_crud.okay')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import AddressCreate from "../addresses/AddressCreate.vue";
import Customer from "@/models/Customer.js";
export default {
  name: "addresses-list",
  props: ['countryCodes'],
  data() {
    return {
      customer: null,
      dialog: false,
      addresses: [],
      pagination: {
          rowsPerPage: 20
      },
      rowsPerPageItems: [
        10,
        20,
        50,
        { text: this.$t("addresses_crud.all"), value: -1 }
      ],
      headers: [
        { text: this.$t("addresses_crud.country"), value: "country" },
        { text: this.$t("addresses_crud.city"), value: "city" },
        { text: this.$t("addresses_crud.street"), value: "street" },
        { text: this.$t("addresses_crud.post_code"), value: "post_code" },
        { text: this.$t("addresses_crud.phone"), value: "phone" },
        { text: this.$t("addresses_crud.ref"), value: "ref" },
        {
          text: this.$t("addresses_crud.actions"),
          value: "actions",
          sortable: false
        }
      ]
    };
  },
  methods: {
    async initialize() {
      const customer = await Customer.loadCustomer(this.customer.id);
      this.addresses = customer.addresses;
      this.dialog = true;
    },

    openAndPrepare(customer){
        this.customer = customer;
        this.addresses = customer.addresses;
        this.dialog = true;
    },
    
    editItem(address){
        this.$refs.addressCreater.openForEdit(address);
    },

    async deleteItem(address){
        const confirmed = confirm(this.$t('addresses_crud.confirm_delete') + " " + address.toString())
        if(!confirmed){
            return 0;
        }
        await address.delete();
        this.initialize();
    },

    getCountryName(code){
        const found = this.countryCodes.find((countryCode) => {
            return countryCode.value == code;
        })
        if(!found){
            return "";
        }
        return found.text;
    }
  },
  components: {
    AddressCreate
  }
};
</script>
